<template>
  <div
    v-if="variants.HEADER_1 === variant"
    class="navigation-header-one position-unset tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-w-full tw-flex-col"
    :class="{
      'scrolled !tw-fixed': isScrolled,
      '!tw-bg-[var(--c-primary)] !tw-shadow-none xl:!tw-bg-white': menuVisible && isScrolled,
    }"
    :style="`
      z-index: 10000;
      ${
        isScrolled || vars.fixedColorBool
          ? `background-color: var(--c-nav-secondary); color: var(--c-text-primary);`
          : 'background-color: transparent;'
      }
      color: ${vars.textColor ? `var(--c-${vars.textColor});` : 'var(--c-text-secondary);'}
    `"
  >
    <div
      v-if="branches.length"
      class="tw-relative tw-hidden tw-w-full tw-items-center tw-justify-end tw-gap-5 tw-px-8 tw-pt-2 tw-duration-300 xl:tw-flex"
      :class="
        (menuVisible && isScrolled) || (menuVisible && vars.fixedColorBool)
          ? '!tw-bg-[var(--c-primary)] !tw-shadow-none xl:!tw-bg-white xl:!tw-shadow'
          : ''
      "
      :style="`
      ${
        menuVisible
          ? 'background-color: var(--c-primary);'
          : isScrolled || vars.fixedColorBool
            ? 'background-color: var(--c-nav); color: var(--c-text-primary);'
            : 'background-color: transparent;'
      }
      color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary) '};
        `"
    >
      <div class="tw-flex tw-gap-4">
        <nuxt-link
          v-for="branch in branches"
          :to="`tel:${branch.phone_number}`"
          :external="true"
          class="n-link tw-text-white"
          :style="`${isScrolled || vars.fixedColorBool ? 'color: var(--c-text-primary)' : ''}`"
        >
          <span class="">{{ branch.name }}: {{ branch.phone_number }}</span>
        </nuxt-link>
      </div>
      <div class="tw-flex tw-items-center tw-justify-start tw-gap-3">
        <nuxt-link
          v-if="vars.facebookUrl"
          :to="vars.facebookUrl"
          :external="true"
          target="_blank"
          class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          :style="`border-color: ${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
        >
          <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="16.5"
              cy="16.5"
              r="16.25"
              :stroke="`${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
              stroke-width="0.5"
            />
            <path
              d="M17.5 17.5H19.5L20 15.5H17.5V14C17.5 13.3 17.5 12.5 19 12.5H20V10H18.5C16 10 15 11 15 13V15.5H13V17.5H15V23H17.5V17.5Z"
              class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              :class="`${isScrolled || vars.fixedColorBool ? '!tw-fill-[#333333]' : 'tw-fill-white'}`"
            />
          </svg>
        </nuxt-link>

        <nuxt-link
          v-if="vars.instagramUrl"
          :to="vars.instagramUrl"
          :external="true"
          target="_blank"
          class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          :style="`border-color: ${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
        >
          <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="16.5"
              cy="16.5"
              r="16.25"
              :stroke="`${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
              stroke-width="0.5"
            />
            <path
              d="M14.2888 10.1952H19.3264C21.2455 10.1952 22.8047 11.7544 22.8047 13.6735V18.711C22.8047 19.6335 22.4382 20.5183 21.7859 21.1706C21.1336 21.8229 20.2489 22.1893 19.3264 22.1893H14.2888C12.3698 22.1893 10.8105 20.6301 10.8105 18.711V13.6735C10.8105 12.751 11.177 11.8663 11.8293 11.214C12.4816 10.5617 13.3663 10.1952 14.2888 10.1952ZM14.1689 11.3946C13.5963 11.3946 13.0472 11.6221 12.6423 12.0269C12.2374 12.4318 12.01 12.981 12.01 13.5536V18.831C12.01 20.0244 12.9755 20.9899 14.1689 20.9899H19.4463C20.0189 20.9899 20.5681 20.7625 20.9729 20.3576C21.3778 19.9527 21.6053 19.4036 21.6053 18.831V13.5536C21.6053 12.3601 20.6397 11.3946 19.4463 11.3946H14.1689ZM19.9561 12.2942C20.1549 12.2942 20.3456 12.3731 20.4862 12.5137C20.6267 12.6543 20.7057 12.845 20.7057 13.0438C20.7057 13.2426 20.6267 13.4333 20.4862 13.5739C20.3456 13.7145 20.1549 13.7934 19.9561 13.7934C19.7573 13.7934 19.5666 13.7145 19.426 13.5739C19.2854 13.4333 19.2064 13.2426 19.2064 13.0438C19.2064 12.845 19.2854 12.6543 19.426 12.5137C19.5666 12.3731 19.7573 12.2942 19.9561 12.2942ZM16.8076 13.1937C17.6029 13.1937 18.3656 13.5096 18.9279 14.072C19.4902 14.6343 19.8062 15.397 19.8062 16.1923C19.8062 16.9875 19.4902 17.7502 18.9279 18.3125C18.3656 18.8749 17.6029 19.1908 16.8076 19.1908C16.0124 19.1908 15.2497 18.8749 14.6873 18.3125C14.125 17.7502 13.8091 16.9875 13.8091 16.1923C13.8091 15.397 14.125 14.6343 14.6873 14.072C15.2497 13.5096 16.0124 13.1937 16.8076 13.1937ZM16.8076 14.3931C16.3305 14.3931 15.8728 14.5827 15.5354 14.9201C15.198 15.2575 15.0085 15.7151 15.0085 16.1923C15.0085 16.6694 15.198 17.127 15.5354 17.4644C15.8728 17.8018 16.3305 17.9914 16.8076 17.9914C17.2848 17.9914 17.7424 17.8018 18.0798 17.4644C18.4172 17.127 18.6067 16.6694 18.6067 16.1923C18.6067 15.7151 18.4172 15.2575 18.0798 14.9201C17.7424 14.5827 17.2848 14.3931 16.8076 14.3931Z"
              class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              :class="`${isScrolled || vars.fixedColorBool ? '!tw-fill-[#333333]' : 'tw-fill-white'}`"
            />
          </svg>
        </nuxt-link>

        <nuxt-link
          v-if="vars.youtubeUrl"
          :to="vars.youtubeUrl"
          :external="true"
          target="_blank"
          class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          :style="`border-color: ${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
        >
          <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="16.5"
              cy="16.5"
              r="16.25"
              :stroke="`${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
              stroke-width="0.5"
            />
            <path
              d="M16.5752 11.3946C17.0879 11.3946 17.6139 11.4078 18.1236 11.4294L18.7257 11.4582L19.3021 11.4923L19.8418 11.5289L20.3348 11.5673C20.8697 11.6083 21.3731 11.8365 21.7564 12.212C22.1396 12.5875 22.3782 13.0861 22.4301 13.6201L22.4541 13.875L22.4991 14.4207C22.5411 14.9862 22.5723 15.6027 22.5723 16.1922C22.5723 16.7818 22.5411 17.3983 22.4991 17.9638L22.4541 18.5095C22.4463 18.5971 22.4385 18.6816 22.4301 18.7644C22.3782 19.2985 22.1395 19.7972 21.7562 20.1727C21.3728 20.5482 20.8692 20.7764 20.3342 20.8172L19.8424 20.855L19.3027 20.8922L18.7257 20.9263L18.1236 20.9551C17.6078 20.9775 17.0915 20.9891 16.5752 20.9899C16.0589 20.9891 15.5426 20.9775 15.0268 20.9551L14.4246 20.9263L13.8483 20.8922L13.3086 20.855L12.8156 20.8172C12.2807 20.7762 11.7773 20.548 11.394 20.1725C11.0107 19.797 10.7722 19.2984 10.7203 18.7644L10.6963 18.5095L10.6513 17.9638C10.6054 17.3744 10.581 16.7835 10.5781 16.1922C10.5781 15.6027 10.6093 14.9862 10.6513 14.4207L10.6963 13.875C10.7041 13.7874 10.7119 13.7029 10.7203 13.6201C10.7722 13.0862 11.0106 12.5877 11.3938 12.2122C11.7769 11.8367 12.2802 11.6084 12.815 11.5673L13.3074 11.5289L13.8471 11.4923L14.424 11.4582L15.0262 11.4294C15.5422 11.407 16.0587 11.3954 16.5752 11.3946ZM16.5752 12.594C16.0804 12.594 15.5713 12.6072 15.0759 12.6276L14.4894 12.6558L13.9263 12.6888L13.3973 12.7247L12.9128 12.7625C12.6581 12.7806 12.4181 12.8883 12.2352 13.0664C12.0523 13.2446 11.9384 13.4817 11.9137 13.7358C11.8435 14.4609 11.7775 15.3635 11.7775 16.1922C11.7775 17.021 11.8435 17.9236 11.9137 18.6487C11.9646 19.1716 12.3796 19.5782 12.9128 19.622L13.3973 19.6592L13.9263 19.6951L14.4894 19.7287L15.0759 19.7569C15.5713 19.7773 16.0804 19.7905 16.5752 19.7905C17.07 19.7905 17.5791 19.7773 18.0745 19.7569L18.661 19.7287L19.2241 19.6957L19.753 19.6598L20.2376 19.622C20.4923 19.6039 20.7323 19.4962 20.9152 19.3181C21.0981 19.1399 21.212 18.9028 21.2367 18.6487C21.3069 17.9236 21.3729 17.021 21.3729 16.1922C21.3729 15.3635 21.3069 14.4609 21.2367 13.7358C21.212 13.4817 21.0981 13.2446 20.9152 13.0664C20.7323 12.8883 20.4923 12.7806 20.2376 12.7625L19.753 12.7253L19.2241 12.6894L18.661 12.6558L18.0745 12.6276C17.575 12.6061 17.0751 12.5949 16.5752 12.594ZM15.3758 14.738C15.3757 14.6793 15.39 14.6216 15.4174 14.5698C15.4447 14.5179 15.4843 14.4736 15.5328 14.4405C15.5812 14.4075 15.6369 14.3868 15.6952 14.3802C15.7534 14.3736 15.8124 14.3813 15.8669 14.4027L15.9155 14.4267L18.4343 15.8804C18.4844 15.9093 18.5269 15.95 18.558 15.9988C18.5891 16.0477 18.6079 16.1033 18.6129 16.161C18.6179 16.2187 18.6089 16.2767 18.5867 16.3302C18.5645 16.3837 18.5297 16.431 18.4853 16.4681L18.4343 16.5041L15.9155 17.9584C15.8648 17.9878 15.8076 18.0043 15.749 18.0066C15.6904 18.0088 15.6321 17.9967 15.5792 17.9713C15.5264 17.9458 15.4805 17.9079 15.4457 17.8607C15.4109 17.8135 15.3881 17.7585 15.3794 17.7005L15.3758 17.6465V14.738Z"
              class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              :class="`${isScrolled || vars.fixedColorBool ? '!tw-fill-[#333333]' : 'tw-fill-white'}`"
            />
          </svg>
        </nuxt-link>

        <nuxt-link
          v-if="vars.tiktokUrl"
          :to="vars.tiktokUrl"
          :external="true"
          target="_blank"
          class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          :style="`border-color: ${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
        >
          <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="16.1921"
              cy="16.1921"
              r="15.9421"
              :stroke="`${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
              stroke-width="0.5"
            />
            <path
              d="M18.9506 12.4802C18.5406 12.0122 18.3147 11.4112 18.3149 10.7891H16.4618V18.2254C16.4475 18.6279 16.2776 19.009 15.9879 19.2887C15.6982 19.5683 15.3112 19.7246 14.9086 19.7247C14.057 19.7247 13.3493 19.029 13.3493 18.1655C13.3493 17.134 14.3448 16.3603 15.3703 16.6782V14.7831C13.3014 14.5072 11.4902 16.1145 11.4902 18.1655C11.4902 20.1625 13.1454 21.5838 14.9026 21.5838C16.7856 21.5838 18.3149 20.0545 18.3149 18.1655V14.3933C19.0663 14.9329 19.9685 15.2225 20.8936 15.2209V13.3678C20.8936 13.3678 19.7662 13.4218 18.9506 12.4802Z"
              class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              :class="`${isScrolled || vars.fixedColorBool ? '!tw-fill-[#333333]' : 'tw-fill-white'}`"
            />
          </svg>
        </nuxt-link>
      </div>
    </div>

    <nav
      class="tw-relative tw-flex tw-w-full tw-items-center tw-px-4 tw-py-8 tw-duration-300 md:tw-px-8 lg:tw-px-16 lg:tw-py-8 xl:tw-py-12"
      :class="
        (menuVisible && isScrolled) || (menuVisible && vars.fixedColorBool)
          ? '!tw-bg-[var(--c-primary)] !tw-shadow-none xl:!tw-bg-white xl:!tw-shadow'
          : ''
      "
      :style="`
      ${
        isScrolled || vars.fixedColorBool
          ? `background-color: var(--c-nav); color: var(--c-text-primary);`
          : 'background-color: transparent;'
      }
          ${menuVisible && !isScrolled ? 'background-color: var(--c-primary); box-shadow: 0 2px 8px 0 rgba(0,0,0,0.08);' : ''}
     
      color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary) '};
      
    `"
    >
      <!-- Mobile Nav -->
      <div class="tw-ml-auto tw-w-[300px] tw-pl-8 xl:tw-hidden">
        <nuxt-link to="/" class="n-link tw-relative tw-block tw-w-full xl:tw-hidden" :external="true">
          <LibraryImage image-class="tw-w-full" :src="logo" :h-ratio="1" :w-ratio="7.2" />
        </nuxt-link>
      </div>
      <div class="tw-ml-auto tw-flex tw-items-center tw-gap-10 xl:tw-hidden">
        <button class="icon burger-menu n-link" @click="toggleMenu">
          <span :class="isScrolled || vars.fixedColorBool ? '!tw-bg-[#333333]' : '!tw-bg-white'"></span>
          <span :class="isScrolled || vars.fixedColorBool ? '!tw-bg-[#333333]' : '!tw-bg-white'"></span>
        </button>
      </div>
      <!-- Mobile Nav End -->

      <!-- Desktop Nav -->

      <div
        class="tw-absolute tw-left-1/2 tw-top-0 tw-hidden tw-h-full tw-w-full tw--translate-x-1/2 tw-items-center tw-justify-center tw-gap-12 tw-px-8 xl:tw-flex"
      >
        <div class="tw-hidden tw-w-full xl:tw-block">
          <ul class="tw-flex tw-w-full tw-items-center tw-justify-end tw-gap-8 tw-whitespace-nowrap tw-align-middle">
            <nuxt-link
              v-if="vars.buttonLinkUrl"
              :to="vars.buttonLinkUrl"
              :external="true"
              :class="{
                'n-primary tw-mr-auto': isScrolled || vars.fixedColorBool,
                'n-tertiary tw-mr-auto': !(isScrolled || vars.fixedColorBool),
              }"
            >
              {{ vars.buttonLabelText }}
            </nuxt-link>

            <li
              v-for="(menuGroup, groupIndex) in leftMenu"
              :key="`menuGroupIndex-${groupIndex}`"
              class="navigation-element tw-group tw-relative tw-duration-300"
              :class="isScrolled || vars.fixedColorBool ? '!tw-text-[#333333]' : '!tw-text-white'"
            >
              <div class="tw-flex tw-items-center tw-justify-center">
                <nuxt-link
                  :external="true"
                  :to="menuGroup.url"
                  :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                  class="n-link tw-text-center tw-uppercase tw-duration-300 hover:tw-text-[var(--c-primary)]"
                >
                  {{ menuGroup.name }}
                </nuxt-link>
              </div>
              <ul
                v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
                class="sub_menu tw-pointer-events-none tw-absolute tw-top-4 tw-max-h-0 tw-rounded-sm tw-border-t-[4px] tw-px-6 tw-text-left tw-opacity-0 tw-duration-300 hover:tw-opacity-100 group-hover:tw-pointer-events-auto group-hover:tw-max-h-[700px] group-hover:!tw-opacity-100"
                :style="`box-shadow: var(--c-box_shadow) ;border-color: var(--c-secondary); background-color: var(--c-primary);color: var(--c-text-primary); `"
              >
                <li
                  v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                  :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                  class="tw-my-4 tw-w-[220px]"
                  style="border-color: var(--c-border)"
                >
                  <nuxt-link
                    class="n-link tw-block tw-text-left tw-uppercase !tw-text-white tw-duration-300 hover:!tw-text-[var(--c-secondary)]"
                    :external="true"
                    :to="subMenu.url"
                    :target="subMenu.is_open_new_tab ? '_blank' : ''"
                  >
                    {{ subMenu.name }}
                  </nuxt-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="tw-w-full tw-max-w-[250px] 2xl:tw-max-w-[320px]">
          <nuxt-link to="/" class="n-link tw-relative tw-block tw-w-full" :external="true">
            <LibraryImage image-class="tw-w-full" :src="logo" :h-ratio="1" :w-ratio="7.2" />
          </nuxt-link>
        </div>

        <div class="tw-hidden tw-w-full xl:tw-block">
          <ul class="tw-flex tw-w-full tw-items-center tw-justify-start tw-gap-8 tw-align-middle">
            <li
              v-for="(menuGroup, groupIndex) in rightMenu"
              :key="`menuGroupIndex-${groupIndex}`"
              class="navigation-element tw-group tw-relative tw-duration-300"
              :class="isScrolled || vars.fixedColorBool ? '!tw-text-[#333333]' : '!tw-text-white'"
            >
              <div class="group tw-flex tw-items-center tw-justify-center">
                <nuxt-link
                  :external="true"
                  :to="menuGroup.url"
                  :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                  class="n-link tw-text-center tw-uppercase tw-duration-300 hover:tw-text-[var(--c-primary)]"
                >
                  {{ menuGroup.name }}
                </nuxt-link>
              </div>
              <ul
                v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
                class="sub_menu tw-pointer-events-none tw-absolute tw-top-4 tw-max-h-0 tw-rounded-sm tw-border-t-[4px] tw-px-6 tw-text-left tw-opacity-0 tw-duration-300 hover:tw-opacity-100 group-hover:tw-pointer-events-auto group-hover:tw-max-h-[700px] group-hover:!tw-opacity-100"
                :style="`box-shadow: var(--c-box_shadow) ;border-color: var(--c-secondary); background-color: var(--c-primary);color: var(--c-text-primary); `"
              >
                <li
                  v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                  :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                  class="tw-my-4 tw-w-[220px]"
                  style="border-color: var(--c-border)"
                >
                  <nuxt-link
                    class="n-link tw-block tw-text-left tw-uppercase !tw-text-white tw-duration-300 hover:!tw-text-[var(--c-secondary)]"
                    :external="true"
                    :to="subMenu.url"
                    :target="subMenu.is_open_new_tab ? '_blank' : ''"
                  >
                    {{ subMenu.name }}
                  </nuxt-link>
                </li>
              </ul>
            </li>
            <div class="tw-ml-auto tw-flex tw-items-center tw-gap-10">
              <button class="icon burger-menu n-link" @click="toggleMenu">
                <span :class="isScrolled || vars.fixedColorBool ? '!tw-bg-[#333333]' : '!tw-bg-white'"></span>
                <span :class="isScrolled || vars.fixedColorBool ? '!tw-bg-[#333333]' : '!tw-bg-white'"></span>
              </button>
            </div>
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <!-- Mobile Menu -->
  <div
    v-if="variants.HEADER_1 === variant"
    class="tw-fixed tw-left-0 tw-top-[-100svh] tw-z-[60] tw-flex tw-h-[100svh] tw-w-full tw-flex-col tw-items-center tw-justify-start tw-gap-y-4 tw-overflow-y-auto tw-bg-black tw-p-4 !tw-pt-20 tw-duration-500 md:tw-gap-y-6 md:!tw-pt-32 xl:tw-pointer-events-none xl:tw-hidden"
    :class="!menuVisible ? '-tw-translate-y-0' : 'tw-translate-y-[100%]'"
    style="z-index: 9999"
    :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}; background-color: var(--c-primary)`"
  >
    <ul class="tw-flex tw-w-full tw-flex-col tw-gap-5 tw-pt-16">
      <li v-for="(menuGroup, groupIndex) in allMenu[0]" :key="`menuGroupIndex-${groupIndex}`" class="tw-w-full tw-px-6">
        <div
          class="tw-flex tw-w-full tw-items-center tw-justify-between tw-pb-3 tw-pt-0"
          @click="toggleSubMenu(groupIndex)"
        >
          <nuxt-link
            :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            :external="true"
            style="font-size: 16px !important"
            class="n-link tw-uppercase tw-text-white tw-duration-300 hover:tw-text-[var(--c-secondary)]"
          >
            {{ menuGroup.name }}
          </nuxt-link>

          <div
            class="tw-flex tw-cursor-pointer tw-items-center tw-rounded tw-bg-transparent tw-p-2"
            v-if="menuGroup.has_sub_menu"
            style="color: white"
          >
            <span
              class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link tw-duration-500"
              :class="{ 'tw-rotate-180': openSubMenu === groupIndex }"
            ></span>
          </div>
        </div>
        <ul
          v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
          class="tw-ml-2 tw-overflow-hidden tw-transition-all tw-duration-500"
          :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
        >
          <li
            v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
            :key="`${subMenuIndex}-subMenu-${groupIndex}`"
            class="tw-pb-2 tw-pt-0"
          >
            <nuxt-link
              :to="subMenu.url"
              :target="subMenu.is_open_new_tab ? '_blank' : ''"
              class="n-link tw-text-white tw-duration-300 hover:tw-text-[var(--c-secondary)]"
              :external="true"
              style="font-size: 16px !important"
            >
              {{ subMenu.name }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="tw-flex tw-w-full tw-flex-col tw-gap-5 tw-px-6 tw-pt-10">
        <small v-for="branch in branches" class="tw-text-white">
          <nuxt-link :to="`tel:${branch.phone_number}`" class="n-link" :external="true">
            {{ branch.name }}: {{ branch.phone_number }}
          </nuxt-link>
        </small>
        <div class="tw-flex tw-w-full tw-items-center tw-justify-start tw-gap-3 tw-pt-4">
          <nuxt-link
            v-if="vars.facebookUrl"
            :external="true"
            :to="vars.facebookUrl"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.4245" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M17.6218 17.0921H19.121L19.7208 14.6932H17.6218V13.4938C17.6218 12.8761 17.6218 12.2944 18.8212 12.2944H19.7208V10.2794C19.5252 10.2536 18.787 10.1954 18.0074 10.1954C16.3792 10.1954 15.2229 11.1891 15.2229 13.0141V14.6932H13.4238V17.0921H15.2229V22.1896H17.6218V17.0921Z"
                fill="white"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>

          <nuxt-link
            v-if="vars.instagramUrl"
            :to="vars.instagramUrl"
            :external="true"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
            style="border-color: white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.8093" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M14.2888 10.1952H19.3264C21.2455 10.1952 22.8047 11.7544 22.8047 13.6735V18.711C22.8047 19.6335 22.4382 20.5183 21.7859 21.1706C21.1336 21.8229 20.2489 22.1893 19.3264 22.1893H14.2888C12.3698 22.1893 10.8105 20.6301 10.8105 18.711V13.6735C10.8105 12.751 11.177 11.8663 11.8293 11.214C12.4816 10.5617 13.3663 10.1952 14.2888 10.1952ZM14.1689 11.3946C13.5963 11.3946 13.0472 11.6221 12.6423 12.0269C12.2374 12.4318 12.01 12.981 12.01 13.5536V18.831C12.01 20.0244 12.9755 20.9899 14.1689 20.9899H19.4463C20.0189 20.9899 20.5681 20.7625 20.9729 20.3576C21.3778 19.9527 21.6053 19.4036 21.6053 18.831V13.5536C21.6053 12.3601 20.6397 11.3946 19.4463 11.3946H14.1689ZM19.9561 12.2942C20.1549 12.2942 20.3456 12.3731 20.4862 12.5137C20.6267 12.6543 20.7057 12.845 20.7057 13.0438C20.7057 13.2426 20.6267 13.4333 20.4862 13.5739C20.3456 13.7145 20.1549 13.7934 19.9561 13.7934C19.7573 13.7934 19.5666 13.7145 19.426 13.5739C19.2854 13.4333 19.2064 13.2426 19.2064 13.0438C19.2064 12.845 19.2854 12.6543 19.426 12.5137C19.5666 12.3731 19.7573 12.2942 19.9561 12.2942ZM16.8076 13.1937C17.6029 13.1937 18.3656 13.5096 18.9279 14.072C19.4902 14.6343 19.8062 15.397 19.8062 16.1923C19.8062 16.9875 19.4902 17.7502 18.9279 18.3125C18.3656 18.8749 17.6029 19.1908 16.8076 19.1908C16.0124 19.1908 15.2497 18.8749 14.6873 18.3125C14.125 17.7502 13.8091 16.9875 13.8091 16.1923C13.8091 15.397 14.125 14.6343 14.6873 14.072C15.2497 13.5096 16.0124 13.1937 16.8076 13.1937ZM16.8076 14.3931C16.3305 14.3931 15.8728 14.5827 15.5354 14.9201C15.198 15.2575 15.0085 15.7151 15.0085 16.1923C15.0085 16.6694 15.198 17.127 15.5354 17.4644C15.8728 17.8018 16.3305 17.9914 16.8076 17.9914C17.2848 17.9914 17.7424 17.8018 18.0798 17.4644C18.4172 17.127 18.6067 16.6694 18.6067 16.1923C18.6067 15.7151 18.4172 15.2575 18.0798 14.9201C17.7424 14.5827 17.2848 14.3931 16.8076 14.3931Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
          <nuxt-link
            v-if="vars.youtubeUrl"
            :to="vars.youtubeUrl"
            :external="true"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
            style="border-color: white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.5769" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M16.5752 11.3946C17.0879 11.3946 17.6139 11.4078 18.1236 11.4294L18.7257 11.4582L19.3021 11.4923L19.8418 11.5289L20.3348 11.5673C20.8697 11.6083 21.3731 11.8365 21.7564 12.212C22.1396 12.5875 22.3782 13.0861 22.4301 13.6201L22.4541 13.875L22.4991 14.4207C22.5411 14.9862 22.5723 15.6027 22.5723 16.1922C22.5723 16.7818 22.5411 17.3983 22.4991 17.9638L22.4541 18.5095C22.4463 18.5971 22.4385 18.6816 22.4301 18.7644C22.3782 19.2985 22.1395 19.7972 21.7562 20.1727C21.3728 20.5482 20.8692 20.7764 20.3342 20.8172L19.8424 20.855L19.3027 20.8922L18.7257 20.9263L18.1236 20.9551C17.6078 20.9775 17.0915 20.9891 16.5752 20.9899C16.0589 20.9891 15.5426 20.9775 15.0268 20.9551L14.4246 20.9263L13.8483 20.8922L13.3086 20.855L12.8156 20.8172C12.2807 20.7762 11.7773 20.548 11.394 20.1725C11.0107 19.797 10.7722 19.2984 10.7203 18.7644L10.6963 18.5095L10.6513 17.9638C10.6054 17.3744 10.581 16.7835 10.5781 16.1922C10.5781 15.6027 10.6093 14.9862 10.6513 14.4207L10.6963 13.875C10.7041 13.7874 10.7119 13.7029 10.7203 13.6201C10.7722 13.0862 11.0106 12.5877 11.3938 12.2122C11.7769 11.8367 12.2802 11.6084 12.815 11.5673L13.3074 11.5289L13.8471 11.4923L14.424 11.4582L15.0262 11.4294C15.5422 11.407 16.0587 11.3954 16.5752 11.3946ZM16.5752 12.594C16.0804 12.594 15.5713 12.6072 15.0759 12.6276L14.4894 12.6558L13.9263 12.6888L13.3973 12.7247L12.9128 12.7625C12.6581 12.7806 12.4181 12.8883 12.2352 13.0664C12.0523 13.2446 11.9384 13.4817 11.9137 13.7358C11.8435 14.4609 11.7775 15.3635 11.7775 16.1922C11.7775 17.021 11.8435 17.9236 11.9137 18.6487C11.9646 19.1716 12.3796 19.5782 12.9128 19.622L13.3973 19.6592L13.9263 19.6951L14.4894 19.7287L15.0759 19.7569C15.5713 19.7773 16.0804 19.7905 16.5752 19.7905C17.07 19.7905 17.5791 19.7773 18.0745 19.7569L18.661 19.7287L19.2241 19.6957L19.753 19.6598L20.2376 19.622C20.4923 19.6039 20.7323 19.4962 20.9152 19.3181C21.0981 19.1399 21.212 18.9028 21.2367 18.6487C21.3069 17.9236 21.3729 17.021 21.3729 16.1922C21.3729 15.3635 21.3069 14.4609 21.2367 13.7358C21.212 13.4817 21.0981 13.2446 20.9152 13.0664C20.7323 12.8883 20.4923 12.7806 20.2376 12.7625L19.753 12.7253L19.2241 12.6894L18.661 12.6558L18.0745 12.6276C17.575 12.6061 17.0751 12.5949 16.5752 12.594ZM15.3758 14.738C15.3757 14.6793 15.39 14.6216 15.4174 14.5698C15.4447 14.5179 15.4843 14.4736 15.5328 14.4405C15.5812 14.4075 15.6369 14.3868 15.6952 14.3802C15.7534 14.3736 15.8124 14.3813 15.8669 14.4027L15.9155 14.4267L18.4343 15.8804C18.4844 15.9093 18.5269 15.95 18.558 15.9988C18.5891 16.0477 18.6079 16.1033 18.6129 16.161C18.6179 16.2187 18.6089 16.2767 18.5867 16.3302C18.5645 16.3837 18.5297 16.431 18.4853 16.4681L18.4343 16.5041L15.9155 17.9584C15.8648 17.9878 15.8076 18.0043 15.749 18.0066C15.6904 18.0088 15.6321 17.9967 15.5792 17.9713C15.5264 17.9458 15.4805 17.9079 15.4457 17.8607C15.4109 17.8135 15.3881 17.7585 15.3794 17.7005L15.3758 17.6465V14.738Z"
                fill="white"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
          <nuxt-link
            v-if="vars.tiktokUrl"
            :to="vars.tiktokUrl"
            :external="true"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.1921" cy="16.1921" r="15.9421" stroke="#fff" stroke-width="0.5" />
              <path
                d="M18.9506 12.4863C18.5406 12.0183 18.3147 11.4173 18.3149 10.7952H16.4618V18.2315C16.4475 18.634 16.2776 19.0151 15.9879 19.2948C15.6982 19.5744 15.3112 19.7307 14.9086 19.7308C14.057 19.7308 13.3493 19.0351 13.3493 18.1716C13.3493 17.1401 14.3448 16.3664 15.3703 16.6843V14.7892C13.3014 14.5134 11.4902 16.1206 11.4902 18.1716C11.4902 20.1686 13.1454 21.5899 14.9026 21.5899C16.7856 21.5899 18.3149 20.0606 18.3149 18.1716V14.3994C19.0663 14.9391 19.9685 15.2286 20.8936 15.227V13.3739C20.8936 13.3739 19.7662 13.4279 18.9506 12.4863Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
        </div>
      </li>
      <li class="tw-w-full tw-px-6 tw-pt-6" v-if="vars.buttonLabelText">
        <nuxt-link :to="vars.buttonLinkUrl" :class="`n-primary`" :external="true">{{ vars.buttonLabelText }}</nuxt-link>
      </li>
    </ul>
  </div>

  <!-- Desktop Menu -->
  <div
    v-if="variants.HEADER_1 === variant"
    class="tw-pointer-events-none tw-fixed tw-right-0 tw-top-0 tw-z-[10001] tw-hidden tw-h-full tw-w-[610px] tw-overflow-y-auto tw-duration-500 xl:tw-pointer-events-auto xl:tw-block"
    :class="menuVisible ? '-tw-translate-x-0' : 'tw-translate-x-[101%]'"
    :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}; background-color: var(--c-primary)`"
  >
    <div class="tw-flex tw-items-center tw-justify-end tw-px-6 tw-pt-10">
      <button class="icon active burger-menu n-link" @click="toggleMenu">
        <span class="!tw-bg-white"></span>
        <span class="!tw-bg-white"></span>
      </button>
    </div>

    <ul class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-pt-8">
      <div class="tw-w-[300px] tw-pb-8">
        <nuxt-link to="/" class="n-link tw-relative tw-block tw-w-full" :external="true">
          <LibraryImage image-class="tw-w-full" :src="company.logo" :h-ratio="1" :w-ratio="7.2" />
        </nuxt-link>
      </div>
      <li v-for="(menuGroup, groupIndex) in remainingMenu" :key="`menuGroupIndex-${groupIndex}`">
        <div
          class="tw-flex tw-w-full tw-items-center tw-justify-between tw-pb-2 tw-pt-0"
          @click="toggleSubMenu(groupIndex)"
        >
          <nuxt-link
            :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            :external="true"
            class="n-link tw-uppercase tw-text-white tw-duration-300 hover:tw-text-[var(--c-secondary)]"
            style="font-size: 16px !important"
          >
            {{ menuGroup.name }}
          </nuxt-link>
          <div
            class="tw-flex tw-cursor-pointer tw-items-center tw-rounded tw-bg-transparent tw-p-2"
            v-if="menuGroup.has_sub_menu"
            style="color: white"
          >
            <span
              class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link tw-duration-500"
              :class="{ 'tw-rotate-180': openSubMenu === groupIndex }"
            ></span>
          </div>
        </div>
        <ul
          v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
          class="tw-overflow-hidden tw-text-center tw-transition-all tw-duration-500"
          :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
        >
          <li
            v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
            :key="`${subMenuIndex}-subMenu-${groupIndex}`"
            class="tw-pb-3 tw-pt-0 tw-uppercase"
          >
            <nuxt-link
              :to="subMenu.url"
              :target="subMenu.is_open_new_tab ? '_blank' : ''"
              class="n-link hover:tw-text-[var(--c-secondary)]"
              :external="true"
              style="color: white !important; font-size: 16px !important"
              :class="`tw-duration-300 hover:tw-text-[var(--c-${vars.hoverTextColor})]`"
            >
              {{ subMenu.name }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <div
        class="tw-flex tw-max-w-[390px] tw-flex-col tw-items-center tw-justify-center tw-gap-5 tw-pt-12 tw-text-center tw-text-white"
      >
        <h3>{{ vars.titleText }}</h3>
        <p style="font-size: 16px !important">{{ vars.descriptionText }}</p>
      </div>
      <div
        class="tw-flex tw-max-w-[390px] tw-flex-col tw-items-center tw-justify-center tw-gap-5 tw-pt-12 tw-text-center tw-text-white"
      >
        <h3>FOLLOW US</h3>
        <div class="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2">
          <nuxt-link
            v-if="vars.facebookUrl"
            :to="vars.facebookUrl"
            :external="true"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.4245" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M17.6218 17.0921H19.121L19.7208 14.6932H17.6218V13.4938C17.6218 12.8761 17.6218 12.2944 18.8212 12.2944H19.7208V10.2794C19.5252 10.2536 18.787 10.1954 18.0074 10.1954C16.3792 10.1954 15.2229 11.1891 15.2229 13.0141V14.6932H13.4238V17.0921H15.2229V22.1896H17.6218V17.0921Z"
                fill="white"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>

          <nuxt-link
            v-if="vars.instagramUrl"
            :to="vars.instagramUrl"
            :external="true"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
            style="border-color: white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.8093" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M14.2888 10.1952H19.3264C21.2455 10.1952 22.8047 11.7544 22.8047 13.6735V18.711C22.8047 19.6335 22.4382 20.5183 21.7859 21.1706C21.1336 21.8229 20.2489 22.1893 19.3264 22.1893H14.2888C12.3698 22.1893 10.8105 20.6301 10.8105 18.711V13.6735C10.8105 12.751 11.177 11.8663 11.8293 11.214C12.4816 10.5617 13.3663 10.1952 14.2888 10.1952ZM14.1689 11.3946C13.5963 11.3946 13.0472 11.6221 12.6423 12.0269C12.2374 12.4318 12.01 12.981 12.01 13.5536V18.831C12.01 20.0244 12.9755 20.9899 14.1689 20.9899H19.4463C20.0189 20.9899 20.5681 20.7625 20.9729 20.3576C21.3778 19.9527 21.6053 19.4036 21.6053 18.831V13.5536C21.6053 12.3601 20.6397 11.3946 19.4463 11.3946H14.1689ZM19.9561 12.2942C20.1549 12.2942 20.3456 12.3731 20.4862 12.5137C20.6267 12.6543 20.7057 12.845 20.7057 13.0438C20.7057 13.2426 20.6267 13.4333 20.4862 13.5739C20.3456 13.7145 20.1549 13.7934 19.9561 13.7934C19.7573 13.7934 19.5666 13.7145 19.426 13.5739C19.2854 13.4333 19.2064 13.2426 19.2064 13.0438C19.2064 12.845 19.2854 12.6543 19.426 12.5137C19.5666 12.3731 19.7573 12.2942 19.9561 12.2942ZM16.8076 13.1937C17.6029 13.1937 18.3656 13.5096 18.9279 14.072C19.4902 14.6343 19.8062 15.397 19.8062 16.1923C19.8062 16.9875 19.4902 17.7502 18.9279 18.3125C18.3656 18.8749 17.6029 19.1908 16.8076 19.1908C16.0124 19.1908 15.2497 18.8749 14.6873 18.3125C14.125 17.7502 13.8091 16.9875 13.8091 16.1923C13.8091 15.397 14.125 14.6343 14.6873 14.072C15.2497 13.5096 16.0124 13.1937 16.8076 13.1937ZM16.8076 14.3931C16.3305 14.3931 15.8728 14.5827 15.5354 14.9201C15.198 15.2575 15.0085 15.7151 15.0085 16.1923C15.0085 16.6694 15.198 17.127 15.5354 17.4644C15.8728 17.8018 16.3305 17.9914 16.8076 17.9914C17.2848 17.9914 17.7424 17.8018 18.0798 17.4644C18.4172 17.127 18.6067 16.6694 18.6067 16.1923C18.6067 15.7151 18.4172 15.2575 18.0798 14.9201C17.7424 14.5827 17.2848 14.3931 16.8076 14.3931Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
          <nuxt-link
            v-if="vars.youtubeUrl"
            :to="vars.youtubeUrl"
            :external="true"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
            style="border-color: white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.5769" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M16.5752 11.3946C17.0879 11.3946 17.6139 11.4078 18.1236 11.4294L18.7257 11.4582L19.3021 11.4923L19.8418 11.5289L20.3348 11.5673C20.8697 11.6083 21.3731 11.8365 21.7564 12.212C22.1396 12.5875 22.3782 13.0861 22.4301 13.6201L22.4541 13.875L22.4991 14.4207C22.5411 14.9862 22.5723 15.6027 22.5723 16.1922C22.5723 16.7818 22.5411 17.3983 22.4991 17.9638L22.4541 18.5095C22.4463 18.5971 22.4385 18.6816 22.4301 18.7644C22.3782 19.2985 22.1395 19.7972 21.7562 20.1727C21.3728 20.5482 20.8692 20.7764 20.3342 20.8172L19.8424 20.855L19.3027 20.8922L18.7257 20.9263L18.1236 20.9551C17.6078 20.9775 17.0915 20.9891 16.5752 20.9899C16.0589 20.9891 15.5426 20.9775 15.0268 20.9551L14.4246 20.9263L13.8483 20.8922L13.3086 20.855L12.8156 20.8172C12.2807 20.7762 11.7773 20.548 11.394 20.1725C11.0107 19.797 10.7722 19.2984 10.7203 18.7644L10.6963 18.5095L10.6513 17.9638C10.6054 17.3744 10.581 16.7835 10.5781 16.1922C10.5781 15.6027 10.6093 14.9862 10.6513 14.4207L10.6963 13.875C10.7041 13.7874 10.7119 13.7029 10.7203 13.6201C10.7722 13.0862 11.0106 12.5877 11.3938 12.2122C11.7769 11.8367 12.2802 11.6084 12.815 11.5673L13.3074 11.5289L13.8471 11.4923L14.424 11.4582L15.0262 11.4294C15.5422 11.407 16.0587 11.3954 16.5752 11.3946ZM16.5752 12.594C16.0804 12.594 15.5713 12.6072 15.0759 12.6276L14.4894 12.6558L13.9263 12.6888L13.3973 12.7247L12.9128 12.7625C12.6581 12.7806 12.4181 12.8883 12.2352 13.0664C12.0523 13.2446 11.9384 13.4817 11.9137 13.7358C11.8435 14.4609 11.7775 15.3635 11.7775 16.1922C11.7775 17.021 11.8435 17.9236 11.9137 18.6487C11.9646 19.1716 12.3796 19.5782 12.9128 19.622L13.3973 19.6592L13.9263 19.6951L14.4894 19.7287L15.0759 19.7569C15.5713 19.7773 16.0804 19.7905 16.5752 19.7905C17.07 19.7905 17.5791 19.7773 18.0745 19.7569L18.661 19.7287L19.2241 19.6957L19.753 19.6598L20.2376 19.622C20.4923 19.6039 20.7323 19.4962 20.9152 19.3181C21.0981 19.1399 21.212 18.9028 21.2367 18.6487C21.3069 17.9236 21.3729 17.021 21.3729 16.1922C21.3729 15.3635 21.3069 14.4609 21.2367 13.7358C21.212 13.4817 21.0981 13.2446 20.9152 13.0664C20.7323 12.8883 20.4923 12.7806 20.2376 12.7625L19.753 12.7253L19.2241 12.6894L18.661 12.6558L18.0745 12.6276C17.575 12.6061 17.0751 12.5949 16.5752 12.594ZM15.3758 14.738C15.3757 14.6793 15.39 14.6216 15.4174 14.5698C15.4447 14.5179 15.4843 14.4736 15.5328 14.4405C15.5812 14.4075 15.6369 14.3868 15.6952 14.3802C15.7534 14.3736 15.8124 14.3813 15.8669 14.4027L15.9155 14.4267L18.4343 15.8804C18.4844 15.9093 18.5269 15.95 18.558 15.9988C18.5891 16.0477 18.6079 16.1033 18.6129 16.161C18.6179 16.2187 18.6089 16.2767 18.5867 16.3302C18.5645 16.3837 18.5297 16.431 18.4853 16.4681L18.4343 16.5041L15.9155 17.9584C15.8648 17.9878 15.8076 18.0043 15.749 18.0066C15.6904 18.0088 15.6321 17.9967 15.5792 17.9713C15.5264 17.9458 15.4805 17.9079 15.4457 17.8607C15.4109 17.8135 15.3881 17.7585 15.3794 17.7005L15.3758 17.6465V14.738Z"
                fill="white"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
          <nuxt-link
            v-if="vars.tiktokUrl"
            :to="vars.tiktokUrl"
            :external="true"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.1921" cy="16.1921" r="15.9421" stroke="#fff" stroke-width="0.5" />
              <path
                d="M18.9506 12.4863C18.5406 12.0183 18.3147 11.4173 18.3149 10.7952H16.4618V18.2315C16.4475 18.634 16.2776 19.0151 15.9879 19.2948C15.6982 19.5744 15.3112 19.7307 14.9086 19.7308C14.057 19.7308 13.3493 19.0351 13.3493 18.1716C13.3493 17.1401 14.3448 16.3664 15.3703 16.6843V14.7892C13.3014 14.5134 11.4902 16.1206 11.4902 18.1716C11.4902 20.1686 13.1454 21.5899 14.9026 21.5899C16.7856 21.5899 18.3149 20.0606 18.3149 18.1716V14.3994C19.0663 14.9391 19.9685 15.2286 20.8936 15.227V13.3739C20.8936 13.3739 19.7662 13.4279 18.9506 12.4863Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
        </div>
      </div>
    </ul>

    <nuxt-link></nuxt-link>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { MenuTypes, ViewTypes } from '~/constants/ui.constants';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';
import { useCoreStore } from '~/units/core/store';

type Menu = {};

export default defineNuxtComponent({
  name: 'Theme8BaseHeaderOne',

  mixins: [ComponentMixin],

  props: {
    component: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      ViewTypes,
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null,
      variants: {
        HEADER_1: 'HEADER_1',
        HEADER_2: 'HEADER_2',
      },
      isActive: false,
      scrollThreshold: 350,
      isLightMode: false,
      isMenuOpen: false,
      scrollPosition: 0,
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['headerMenuItems']),
    ...mapState(useCoreStore, ['isAnythingOnTopVisible']),

    headerMenu() {
      return this.headerMenuItems as Menu[];
    },

    branches() {
      return this.groupedVariables.branches;
    },

    routeUrl() {
      const route = useRoute();
      return route.path;
    },

    allMenu() {
      const period = 9;
      const columnsCount = Math.ceil(this.columnOneMenu.length / period);
      const groups = [];

      for (let i = 0; i < columnsCount; i++) {
        groups[i] = [];
        for (let p = 0; p < period; p++) {
          const index = period * i + p;
          if (this.columnOneMenu[index]) {
            groups[i].push(this.columnOneMenu[index]);
          }
        }
      }

      return groups;
    },

    columnOneMenu() {
      const content = this.component.variables['column_one_content-text'];
      if (content === MenuTypes.HEADER_MENU) {
        return this.headerMenu;
      }
      return [];
    },

    leftMenu() {
      return this.allMenu[0].slice(0, 2);
    },
    rightMenu() {
      return this.allMenu[0].slice(2, 5);
    },
    remainingMenu() {
      return this.allMenu[0].slice(5);
    },

    logo() {
      if (this.menuVisible) {
        return this.company.logo;
      } else if (this.isScrolled) {
        return this.company.light_logo;
      } else if (!this.vars.fixedColorBool && !this.isScrolled) {
        return this.company.logo;
      }
      return this.company.light_logo;
    },

    navTextColor() {
      if (this.isScrolled) {
        return 'primary';
      }
      return this.vars.navTextColor || 'secondary';
    },
  },

  methods: {
    toggleSubMenu(index) {
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },

    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      if (this.menuVisible) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
      this.toggleActiveClass();
    },

    toggleBurgerMenu() {
      if (!this.menuVisible) {
        const navItems = document.querySelectorAll('.nav-item');
        navItems.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('nav-item-visible');
          }, index * 150);
        });
      } else {
        const navItems = document.querySelectorAll('.nav-item');
        navItems.forEach((item, index) => {
          setTimeout(
            () => {
              item.classList.remove('nav-item-visible');
            },
            (navItems.length - index) * 150,
          );
        });
        setTimeout(() => {
          this.menuVisible = false;
          document.body.classList.remove('burger-menu-visible');
          document.body.classList.remove('no-scroll');
        }, navItems.length * 150);
        return;
      }

      this.menuVisible = !this.menuVisible;
      document.body.classList.toggle('burger-menu-visible', this.menuVisible);
      if (this.menuVisible) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > this.scrollThreshold;
    },
    toggleTheme() {
      this.isLightMode = !this.isLightMode;
      const htmlElement = document.documentElement;
      htmlElement.classList.toggle('light-mode');

      // Optionally, save the theme preference in localStorage
      if (htmlElement.classList.contains('light-mode')) {
        localStorage.setItem('theme', 'light');
      } else {
        localStorage.setItem('theme', 'dark');
      }
    },

    toggleActiveClass() {
      const burgerMenu = document.querySelector('.burger-menu');
      burgerMenu.classList.toggle('active');
      burgerMenu.querySelectorAll('span').forEach((span) => {
        span.classList.toggle('active');
      });
    },

    closeBurgerMenu() {
      this.menuVisible = false;
      document.body.classList.remove('burger-menu-visible');
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();

    if (this.menuVisible) {
      document.body.classList.add('no-scroll');
    }

    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light') {
      this.isLightMode = true;
      document.documentElement.classList.add('light-mode');
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.classList.remove('no-scroll');
  },
});
</script>
<style>
.no-scroll {
  overflow: hidden;
  width: 100%;
}
</style>
<style scoped>
::-webkit-scrollbar {
  display: none;
}

.nav-item {
  transform: translateY(-20px);
  opacity: 0;
  transition: all 0.4s ease-in-out;
}

.nav-item-visible {
  transform: translateY(0);
  opacity: 1;
}

.nav-item-closing {
  animation: fadeOutToBottom 0.4s forwards;
}

@keyframes fadeOutToBottom {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(20px);
    opacity: 0;
  }
}

.nav-menu {
  opacity: 0;
  pointer-events: none;
  transition: all 0.5s ease-in-out;
}

.burger-menu-visible .nav-menu {
  opacity: 1;
  pointer-events: initial;
}

.burger-menu-visible .navbar {
  background-color: transparent !important;
}

button.icon {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: transparent;
  cursor: pointer;
  align-items: center;
  width: 40px;
  height: 40px;
  justify-content: center;
  border: 1.3px solid inherit;
  border-radius: 8px;
}

button.icon > span {
  height: 2px;
  width: 32px;
  background: inherit;
  border-radius: 30px;
  transition: all 0.3s linear;
}

/* Hover effects */
button.icon:hover > span {
  width: 32px;
}
button.icon.active:hover > span {
  width: 32px;
  margin-left: 0;
}

button.icon:hover > span:nth-child(2) {
  width: 32px;
  margin-left: 0;
}

button.icon.active {
  border-color: #fff !important;
}

button.icon.active > span {
  transform: rotate(45deg);
  margin-bottom: -4px;
}

button.icon.active > span.active {
  background: #fff !important;
}

button.icon.active > span:nth-child(2) {
  width: 32px;
  margin-left: 0;
  margin-top: -5px;
  transform: rotate(-45deg);
  margin-bottom: 0;
}

button.icon span {
  transition: 0.3s ease-in-out;
}

.scrolled {
  animation: fadeIn 0.8s ease-in-out;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    top: -50px;
  }
  to {
    opacity: 1;
    top: 0;
  }
}
</style>
